import { render, staticRenderFns } from "./PlantVarietyReformerList.vue?vue&type=template&id=01edfb77&"
import script from "./PlantVarietyReformerList.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyReformerList.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyReformerList.vue?vue&type=style&index=0&id=01edfb77&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports